import CommonIcon from '~/components/common/Icon.vue';

// Nuxt auto-registers components/common/Icon.vue as <CommonIcon>, but pages
// use <Icon>, which rendered nothing (empty password toggle, modal close,
// pagination chevrons, spinners). Register it under the name pages use.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Icon', CommonIcon);
});
